import React, { useMemo } from 'react';
import { ThemeProvider, useTheme } from 'styled-components';
import { applyAppsTheme } from '@stylesheets/appsTheme';

const AppsThemeBoundary: React.FC<{ readonly children: React.ReactNode }> = ({ children }) => {
  const base = useTheme();
  const theme = useMemo(() => applyAppsTheme(base), [base]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AppsThemeBoundary;
